import {isNullOrUndefined} from "../../services/Validator";

export default function SystemNavigationItemName({name}) {
    // Used in SystemDrawerNavigationItem to display item name

    // BUILD
    if (isNullOrUndefined(name))
        return null
    return (
        <span className={"text-[16px]"}>
            {name}
        </span>
    );
}